module.exports = __webpack_public_path__ + "static/media/camper.a196cc03.png";